import React from "react"
import * as locationCSS from  "./locations.module.sass"

const Locations = ({ inverted }) => (
  <p className={[locationCSS.locations, inverted === true ? locationCSS.inverted : ''].join(' ')}>VANCOUVER | BERLIN</p>
)

export default Locations